module.exports = __webpack_public_path__ + "static/media/rocketppe_kn95.b1c94237.jpg";